import { render, staticRenderFns } from "./WeekText.vue?vue&type=template&id=2e646a9c"
import script from "./WeekText.vue?vue&type=script&lang=ts"
export * from "./WeekText.vue?vue&type=script&lang=ts"
import style0 from "./WeekText.vue?vue&type=style&index=0&id=2e646a9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports